const INITIAL_STATE = {
  working: false,
  jobs: 0,
  /**
   * What is being loaded, for the indicator to say. Empty when nothing was announced - a job that
   * only raises `working` still shows the indicator, just without a subject.
   */
  notice: { title: "", detail: "" },
};

export const reducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case "EVALUATE":
      return { ...state, jobs: state.jobs + 1, working: true };
    case "DONE":
      return {
        ...state,
        jobs: state.jobs - 1,
        working: state.jobs === 1 ? false : true,
      };
    case "LOADING_NOTICE":
      return { ...state, notice: { title: payload.title, detail: payload.detail } };
    default:
      return state;
  }
};

export default reducer;
